import { render } from "./CElementCover.vue?vue&type=template&id=9b50c512"
import script from "./CElementCover.vue?vue&type=script&lang=js"
export * from "./CElementCover.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__